// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3K557","header":"MessagesList_header__3I_d_","chat":"MessagesList_chat__2E28L"};